import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { PartnershipValidation, ValidatePartnershipCard } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface PartnershipValidationStepParams extends DefaultHttpHeaders {}

@Injectable()
export class PartnershipValidationStepService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  // tslint:disable max-line-length
  /**
   * Retrieve if user can see the "Partership" step
   * Retrieve if user has the conditions to be able to see the "Partership" step
   * and if is required to fill the partnership card field
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Application%20Utilities/getPartnershipValidationStep
   */
  partnershipValidationStep(
    body: ValidatePartnershipCard,
    params: PartnershipValidationStepParams
  ): Observable<PartnershipValidation> {
    return this.post<ValidatePartnershipCard, PartnershipValidation>({
      suffix: '/comeround/applicationUtilities/partnershipValidationStep',
      body,
    });
  }
}
